/**
 * @desc 获取出库单还货数据,根据sku分组
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(code: string | number, options?: any) {
  return updateResponse(
    http(URL + `/outMaster/returnGroupBySku/${code}`, {
      method: "GET",

      ...options,
    }),
  );
}
